import { createHttpEndpoint } from '../../utils'

import type { GetReviews } from './reviews.types'

/**
 * Retrieve reviews as an authenticated seller.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#/Reviews/get-bm-merchants-reviews}
 */
export const getReviews = createHttpEndpoint<GetReviews>({
  method: 'GET',
  operationId: 'getReviews',
  path: '/bm/merchants/reviews',
})
